module.exports = __webpack_public_path__ + "img/leonore.88f8e2da.png";